import { ArrowTurnDownRightIcon } from "@heroicons/react/24/outline";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import {
  MoveSectionActionEnum,
  ReportSectionsType,
  useMoveSectionToOrFromAppendixMutation,
} from "@api/graphql/types-and-hooks";
import { notifyError } from "@components/notifications/notifications";
import { useReport } from "@providers/ReportProvider";

interface Props {
  section: ReportSectionsType;
}

export const ReportSectionActionMenuMoveToAppendix: React.FC<Props> = ({ section }) => {
  const { reportQuery } = useReport();
  const { mutate: moveSectionMutate } = useMoveSectionToOrFromAppendixMutation({
    onSuccess: async (data) => {
      if (data.moveReportSection?.status) {
        await reportQuery.refetch();
      } else if (data.moveReportSection?.status === false) {
        notifyError(data.moveReportSection?.message ?? "Error Moving Section to Appendix");
      }
    },
    onError: (error) => {
      console.error("Error moving section to appendix:", error);
      notifyError("Error Moving Section to Appendix");
    },
  });

  return (
    <DropdownMenuItem
      onClick={() =>
        moveSectionMutate({ input: { reportSectionId: section.id, action: MoveSectionActionEnum.MoveToAppendix } })
      }
    >
      <ArrowTurnDownRightIcon />
      Send to Appendix
    </DropdownMenuItem>
  );
};
